import { render, staticRenderFns } from "./ServizioPeriodicoPeriod.vue?vue&type=template&id=675c239f&"
import script from "./ServizioPeriodicoPeriod.vue?vue&type=script&lang=ts&"
export * from "./ServizioPeriodicoPeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports